import { CtaTypes } from '../CTA';
import HeroContainer from './HeroContainer';
import ImageHero from './ImageHero';
import NoImageHero from './NoImageHero';

const ProductHero = ({
  header,
  subheader,
  onSubmit = null,
  ctaType = CtaTypes.email,
  href = null,
  buttonText = 'Sign Up',
  showPeriod = false,
  imageSrc = null,
  imageAlt = null,
}) => {
  return (
    <HeroContainer>
      {imageSrc ? (
        <ImageHero
          ctaType={ctaType}
          buttonText={buttonText}
          onSubmit={onSubmit}
          header={header}
          subheader={subheader}
          showPeriod={showPeriod}
          href={href}
          imageSrc={imageSrc}
          imageAlt={imageAlt}
        />
      ) : (
        <NoImageHero
          ctaType={ctaType}
          buttonText={buttonText}
          href={href}
          onSubmit={onSubmit}
          header={header}
          subheader={subheader}
          showPeriod={showPeriod}
        />
      )}
    </HeroContainer>
  );
};

export default ProductHero;
